export default __webpack_public_path__ + "static/media/Loader.14870871.svg";